import { Button, Stack, TextField, Typography } from "@mui/material";
import axios from "axios";
import { useFormik } from "formik";
import React, { useState } from "react";
import { ClipLoader } from "react-spinners";
import * as yup from 'yup'
import { useLoading } from "../shared/hooks/useLoading";
import { BreachDetails } from "./BreachDetails";
import { IBreachDetails } from "./models/breach-details.interface";

interface IForm {
  ticketNbr: string
  vrm: string
}

type ExtractStringPropertyNames<T> = {
  [K in keyof T]: T[K] extends string ? K : never
}[keyof T]

type IFormKeys = ExtractStringPropertyNames<IForm>

const validationSchema = yup.object({
  ticketNbr: yup.string().required('Enter your breach ID'),
  vrm: yup.string().required('Enter your vehicle registation number'),
})

export const BreachSearch: React.FC = () => {
  const [details, setDetails] = useState<IBreachDetails | null>(null)
  const {loading, setLoading} = useLoading()
  const [hasError, setHasError] = useState<boolean>(false)

  const formik = useFormik<IForm>({
    initialValues: {
      ticketNbr: '',
      vrm: '',
    },
    validationSchema,
    onSubmit: async (values: IForm) => {
      setLoading(true)
      setDetails(null)
      setHasError(false)
      try {
        const response = await axios.get<IBreachDetails>(`${process.env.REACT_APP_API_URL}/breach/${values.ticketNbr}/${values.vrm}`)
        setDetails(response.data)
      } catch (error) {
        setHasError(true)
      }
      setLoading(false)
    }
  })

  const { values, touched, errors, setFieldValue } = formik

  const handleChangeForm = (field: IFormKeys) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(field, e.target.value)
  }

  return (
    <Stack spacing={2}>
      <form onSubmit={formik.handleSubmit}>
        <Stack direction="column" spacing={2}>
          {/* <Typography variant='h4'>View Parking Breach Details</Typography> */}
          <Stack direction="column" spacing={1}>
            <Typography variant="body1">Vehicle Registration *</Typography>
            <TextField fullWidth value={values.vrm} onChange={handleChangeForm('vrm')}
              size='small' variant="outlined"
              error={touched.vrm && !!errors.vrm}
              helperText={touched.vrm && errors.vrm}></TextField>
          </Stack>
          <Stack direction="column" spacing={1}>
            <Typography variant="body1">Breach ID *</Typography>
            <TextField fullWidth value={values.ticketNbr} onChange={handleChangeForm('ticketNbr')}
              size='small' variant="outlined"
              error={touched.ticketNbr && !!errors.ticketNbr}
              helperText={touched.ticketNbr && errors.ticketNbr}></TextField>
          </Stack>
          <Stack alignItems='flex-start'>
            <Button variant="contained" type="submit" disabled={loading}>Next</Button>
          </Stack>
        </Stack>
      </form>
      <Stack alignItems={"center"}>
        <ClipLoader loading={loading} size={150} />
        {
          details && <BreachDetails details={details} />
        }
        {
          hasError && <Typography variant="h3">No results were found.</Typography>
        }
      </Stack>
    </Stack>
  )
}